export default __webpack_public_path__ + "static/media/video_6_botrytida.0c8347b9.mp4";